import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { adminAPI } from '../../services/api';
import AdminLayout from '../../components/admin/AdminLayout';
import {
  LayoutDashboard,
  Users,
  FolderOpen,
  FileText,
  ChevronRight,
  Loader
} from 'lucide-react';

function DashboardPage() {
  const [stats, setStats] = useState({
    users: 0,
    projects: 0,
    areas: 0,
    documents: 0
  });
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [usersRes, projectsRes] = await Promise.all([
        adminAPI.getUsers(),
        adminAPI.getProjects()
      ]);

      const projectsData = projectsRes.data.projects || [];
      let totalAreas = 0;
      let totalDocs = 0;

      projectsData.forEach(p => {
        totalAreas += p.stats?.areasCount || 0;
        totalDocs += p.stats?.documentsCount || 0;
      });

      setStats({
        users: usersRes.data.users?.length || 0,
        projects: projectsData.length,
        areas: totalAreas,
        documents: totalDocs
      });
      setProjects(projectsData.slice(0, 5));
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={<h1>Dashboard</h1>}>
      {loading ? (
        <div className="admin-loading">
          <Loader size={32} className="loading-spinner" />
          <p>Cargando estadísticas...</p>
        </div>
      ) : (
        <>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon users">
                <Users size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.users}</h3>
                <p>Usuarios</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon projects">
                <FolderOpen size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.projects}</h3>
                <p>Proyectos</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon areas">
                <LayoutDashboard size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.areas}</h3>
                <p>Áreas</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon documents">
                <FileText size={24} />
              </div>
              <div className="stat-info">
                <h3>{stats.documents}</h3>
                <p>Documentos</p>
              </div>
            </div>
          </div>

          <div className="dashboard-section">
            <div className="section-header">
              <h2>Proyectos Recientes</h2>
              <Link to="/admin/projects" className="section-link">
                Ver todos <ChevronRight size={16} />
              </Link>
            </div>
            {projects.length === 0 ? (
              <div className="empty-section">
                <FolderOpen size={48} />
                <p>No hay proyectos creados</p>
                <Link to="/admin/projects" className="btn-primary">
                  Crear Proyecto
                </Link>
              </div>
            ) : (
              <div className="recent-projects">
                {projects.map(project => (
                  <Link
                    key={project.id}
                    to={`/admin/projects/${project.id}`}
                    className="recent-project-card"
                  >
                    <div className="project-card-header">
                      <FolderOpen size={20} />
                      <h3>{project.name}</h3>
                    </div>
                    <p className="project-description">
                      {project.description || 'Sin descripción'}
                    </p>
                    <div className="project-stats">
                      <span>{project.stats?.areasCount || 0} áreas</span>
                      <span>{project.stats?.documentsCount || 0} docs</span>
                      <span>{project.stats?.usersCount || 0} usuarios</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </AdminLayout>
  );
}

export default DashboardPage;
